import { injectTSDI } from '../tsdi';
import { Api } from '../api';
import { ConnectApiTaxIdDto, TaxIdValidationResultDto } from '../api/dtos';
import { generateValidCodiceFiscale } from '../dev';
import { featureEnabled } from '../features';
import {
    CountryValidationConfig,
    shouldValidateForCountry
} from './country-validation';

export type TaxIdValidationData = Omit<ConnectApiTaxIdDto, 'taxId'>;

type TaxIdValidationError = NonNullable<
    TaxIdValidationResultDto['errors']
>[number];

export const validateTaxId = (
    getTexIdData: () => TaxIdValidationData,
    countryConfig?: CountryValidationConfig
) => async (value: string) => {
    if (!value) {
        return false;
    }

    if (!shouldValidateForCountry(countryConfig)) {
        return false;
    }

    const api = injectTSDI(Api);
    const data = getTexIdData();

    const {
        valid,
        errors
    } = await api.client.ConnectApiValidationController.validateTaxId({
        ...data,
        taxId: value.toLocaleUpperCase()
    });

    if (valid) {
        return false;
    } else {
        // display valid codice fiscale in the console for easier testing
        if (featureEnabled('IS_DEV')) {
            generateValidCodiceFiscale(data).then(console.info);
        }

        return getErrorKey(errors);
    }
};

const getErrorKey = (errors: TaxIdValidationError[] = []) => {
    const firstError = errors[0];

    switch (firstError) {
        case 'INVALID_TAX_ID':
            return 'errormessage.validation.taxid';
        case 'MISSING_LASTNAME':
        case 'MISSING_FIRSTNAME':
        case 'MISSING_GENDER':
        case 'UNSUPPORTED_GENDER':
        case 'MISSING_DATE_OF_BIRTH':
        case 'MISSING_PLACE_OR_COUNTRY_OF_BIRTH':
            return 'onlinepages.taxid.information.missing';
    }
};
